import React from 'react';
import clsx from 'clsx';
import {faPlus, faFileAlt} from '@netx/core-icons';
import {TableView} from '@netx/core-app-next/components/TableView';
import {Button} from '@netx/core-components/Button';
import {
	composeClasses,
	styled,
	type WithClasses,
} from '@netx/core-components/Theme';
import {
	AssetViewActionLabel,
	AssetViewsSubTitle,
	AssetViewsTitle,
} from '../../locales';
import {AssetViewsFiltersContainer} from '../AssetViewsFilters';
import {AssetViewsTableContainer} from '../AssetViewsTable';
import {
	assetViewsClasses,
	getAssetViewsUtilityClass,
	AssetViewsClasses,
	ASSET_VIEWS_CLASS_NAME,
} from './assetViewsClasses';

type IAssetViewsOwnerState = WithClasses<AssetViewsClasses, {}>;

const useUtilityClasses = (ownerState: IAssetViewsOwnerState) => {
	const {classes} = ownerState;
	const slots = {
		root: ['root'],
	};
	return composeClasses(slots, getAssetViewsUtilityClass, classes);
};

const AssetViewsRoot = styled(TableView, {
	name: ASSET_VIEWS_CLASS_NAME,
	slot: 'Root',
})(({theme}) => ({}));

export interface AssetViewsProps extends WithClasses<AssetViewsClasses> {
	disabled?: boolean;
	filter: string;
	loading?: boolean;
	totalRows: number;
	onCreate?: () => void;
}

export const AssetViewsPrimitive = ({
	classes: _classes,
	className,
	disabled,
	filter,
	loading,
	totalRows,
	onCreate,
}: AssetViewsProps) => {
	const classes = useUtilityClasses({
		classes: _classes,
		className,
	});

	return (
		<AssetViewsRoot
			className={clsx(classes.root, className)}
			controls={
				onCreate ? (
					<Button
						disabled={loading || disabled}
						startIcon={faPlus}
						variant="outlined"
						onClick={() => onCreate()}
					>
						{AssetViewActionLabel.CREATE}
					</Button>
				) : null
			}
			filters={<AssetViewsFiltersContainer disabled={loading || disabled} />}
			title={AssetViewsTitle.VIEWS}
			TitleProps={{
				loading,
				icon: faFileAlt,
				showPrimaryTitleWhileLoading: true,
				secondary: AssetViewsSubTitle.TOTAL(totalRows),
			}}
		>
			<AssetViewsTableContainer loading={loading} disabled={disabled} />
		</AssetViewsRoot>
	);
};

/**
 * `AssetViews` is a component for rendering and managing asset views with support for dynamic filtering.
 */
export const AssetViews = AssetViewsPrimitive;

export default AssetViews;
